import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const Ctx = createContext(null);

export function SubscriptionProvider({ children }) {
  const { user } = useAuth();
  const [state, setState] = useState({ entitlement: null, plans: [], durations: [1, 6, 12], instructions: {}, requests: [] });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) {
      setState((s) => ({ ...s, entitlement: null }));
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.get("/plan/status");
      setState(data);
    } catch {
      // Do not lock out on transient errors; retry if never loaded.
      setState((prev) => {
        if (!prev.entitlement) setTimeout(() => refresh(), 3000);
        return prev;
      });
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <Ctx.Provider value={{ ...state, loading, refresh }}>{children}</Ctx.Provider>;
}

export const useSubscription = () => useContext(Ctx);
